import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";

const performPost = (purchaseId: string | undefined) => {
  return api.rawPost(`api/purchases/${purchaseId}/resume`);
};

export default function useLogResumeClickMutation() {
  return useMutation({ mutationFn: performPost });
}
